import InvitationsShowContainer from './invitations_show_container';

const InvitationsShow = InvitationsShowContainer;

export default InvitationsShow;
